import { apiClient } from '@/shared/lib/api/client';
import type {
  Colaborador,
  ColaboradorRequest,
  CargoLookup,
  Escola,
  Turma,
  UsuarioHistoricoItem,
} from '@/types/api';

export const colaboradorService = {
  listar: async (): Promise<Colaborador[]> => {
    const { data } = await apiClient.get<Colaborador[]>('/v1/colaboradores');
    return data;
  },

  obter: async (id: number): Promise<Colaborador> => {
    const { data } = await apiClient.get<Colaborador>(`/v1/colaboradores/${id}`);
    return data;
  },

  criar: async (payload: ColaboradorRequest): Promise<Colaborador> => {
    const { data } = await apiClient.post<Colaborador>('/v1/colaboradores', payload);
    return data;
  },

  atualizar: async (id: number, payload: ColaboradorRequest): Promise<Colaborador> => {
    const { data } = await apiClient.put<Colaborador>(`/v1/colaboradores/${id}`, payload);
    return data;
  },

  excluir: async (id: number): Promise<void> => {
    await apiClient.delete(`/v1/colaboradores/${id}`);
  },

  listarCargos: async (idEscola: number): Promise<CargoLookup[]> => {
    const { data } = await apiClient.get<CargoLookup[]>('/v1/cargos', { params: { idEscola } });
    return data;
  },

  listarEscolas: async (): Promise<Escola[]> => {
    const { data } = await apiClient.get<Escola[]>('/v1/escolas');
    return data;
  },

  listarTurmas: async (): Promise<Turma[]> => {
    const { data } = await apiClient.get<Turma[]>('/v1/turmas');
    return data;
  },

  removerUsuario: async (id: number): Promise<void> => {
    await apiClient.delete(`/v1/colaboradores/${id}/usuario`);
  },

  redefinirSenhaUsuario: async (id: number): Promise<void> => {
    await apiClient.post(`/v1/colaboradores/${id}/usuario/redefinir-senha`);
  },

  linkAtivacaoUsuario: async (id: number): Promise<{ url: string; token: string; expiraEm: number }> => {
    const { data } = await apiClient.get<{ url: string; token: string; expiraEm: number }>(
      `/v1/colaboradores/${id}/usuario/link-ativacao`,
    );
    return data;
  },

  historicoUsuario: async (id: number): Promise<UsuarioHistoricoItem[]> => {
    const { data } = await apiClient.get<UsuarioHistoricoItem[]>(
      `/v1/colaboradores/${id}/usuario/historico`,
    );
    return data;
  },
};
